// extracted by css-extract-rspack-plugin
export default {"root":"root-gx_s2W","dot":"dot-LQtWaJ","dotPulse":"dotPulse-YHnZCt"};